/* eslint-disable no-underscore-dangle */
import { parse, parseISO, format, addMinutes, addDays, startOfDay, isBefore, getDay } from 'date-fns';
import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT } from 'constants/logic';
import { REPEAT_WEEKLY_OPTIONS } from './ClasstivitySchedulerForm';

// https://date-fns.org/v2.22.1/docs/getDay
const MAP_DAY_OF_WEEK_TO_NUMBER = {
  Su: 0,
  Mo: 1,
  Tu: 2,
  We: 3,
  Th: 4,
  Fr: 5,
  Sa: 6,
};

export const generateScheduleInstances = ({ classId, startDate, endDate, startAndDuration, repeatWeekly, days }) => {
  const scheduleInstances = [];

  if (repeatWeekly === REPEAT_WEEKLY_OPTIONS.NO) {
    startAndDuration.forEach(({ duration, startTime }) => {
      const parsedStartTime = parse(startTime, 'HH:mm', new Date());
      return scheduleInstances.push({
        classId,
        classDate: format(parseISO(startDate), SERVER_DATE_FORMAT),
        startTime: format(parsedStartTime, SERVER_TIME_FORMAT),
        endTime: format(addMinutes(parsedStartTime, duration), SERVER_TIME_FORMAT),
      });
    });
  }

  if (repeatWeekly === REPEAT_WEEKLY_OPTIONS.YES) {
    const occurrenceDates = [];
    const daysOfWeek = days.map(day => MAP_DAY_OF_WEEK_TO_NUMBER[day]);

    const parsedEndDate = parseISO(endDate);

    for (
      let runningDate = startOfDay(parseISO(startDate));
      isBefore(runningDate, parsedEndDate);
      runningDate = addDays(runningDate, 1)
    ) {
      if (daysOfWeek.includes(getDay(runningDate))) {
        occurrenceDates.push(runningDate);
      }
    }

    occurrenceDates.forEach(occurrenceDate =>
      startAndDuration.forEach(({ duration, startTime }) => {
        const parsedStartTime = parse(startTime, 'HH:mm', new Date());
        return scheduleInstances.push({
          classId,
          classDate: format(occurrenceDate, SERVER_DATE_FORMAT),
          startTime: format(parsedStartTime, SERVER_TIME_FORMAT),
          endTime: format(addMinutes(parsedStartTime, duration), SERVER_TIME_FORMAT),
        });
      })
    );
  }

  return scheduleInstances;
};

export const detectDuplicates = (oldSchedules, newSchedules) => {
  const getKey = ({ classId, classDate, startTime }) => `${classId}-${classDate}-${startTime}`;
  const oldScheduleKeys = new Set(oldSchedules.map(getKey));
  let hasDuplicates = false;

  const schedulesWithFlaggedDuplicates = newSchedules.map(schedule => {
    if (oldScheduleKeys.has(getKey(schedule))) {
      hasDuplicates = true;
      return { _isDuplicate: true, ...schedule };
    }
    return schedule;
  });

  return {
    hasDuplicates,
    schedules: schedulesWithFlaggedDuplicates,
  };
};

export const mapScheduleInstancesToCreateSchedulesData = scheduleInstances => {
  const classtivityScheduleInstances = scheduleInstances.map(({ classId, classDate, startTime, endTime }) => {
    return {
      classivityClassId: classId,
      startDate: classDate,
      startTime,
      endTime,
      teacherId: null,
      teacherName: null,
    };
  });
  return classtivityScheduleInstances;
};
